module.exports = __webpack_public_path__ + "media/images/orion_pictos/examinateur-b2421f53e51c69b240ea508e8d2d33a0.png";